module.exports = __webpack_public_path__ + "assets/皇冠VIP1.ba6c053c.svg";